/* ZERON homepage interactions (ported 1:1 from local site, guarded) */
document.addEventListener('DOMContentLoaded', function(){
  // Popup — show once per browser session only
  var overlay=document.getElementById('popupOverlay');
  function closePopup(e){ if(e&&e.preventDefault)e.preventDefault(); if(!overlay)return; overlay.classList.add('hidden'); setTimeout(function(){overlay.style.display='none';},400); try{sessionStorage.setItem('zeron_popup_shown','1');}catch(err){} }
  window.closePopup=closePopup; window.closePopupSkip=function(){closePopup();};
  var pc=document.getElementById('popupClose'); if(pc)pc.addEventListener('click',closePopup);
  if(overlay){
    var alreadyShown=false;
    try{ alreadyShown = sessionStorage.getItem('zeron_popup_shown')==='1'; }catch(err){}
    if(alreadyShown){ overlay.style.display='none'; }
    else { try{ sessionStorage.setItem('zeron_popup_shown','1'); }catch(err){} }
  }

  // Mobile menu
  var burger=document.getElementById('burgerBtn'), mobileMenu=document.getElementById('mobileMenu'), mobileClose=document.getElementById('mobileClose');
  if(burger&&mobileMenu){ burger.addEventListener('click',function(){mobileMenu.classList.add('open');}); }
  if(mobileClose&&mobileMenu){ mobileClose.addEventListener('click',function(){mobileMenu.classList.remove('open');}); }
  if(mobileMenu){ mobileMenu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mobileMenu.classList.remove('open');});}); }

  // Fade-up reveal
  if('IntersectionObserver' in window){
    var ob=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');ob.unobserve(e.target);}});},{threshold:0.1});
    document.querySelectorAll('.fade-up').forEach(function(el){ob.observe(el);});
  } else { document.querySelectorAll('.fade-up').forEach(function(el){el.classList.add('visible');}); }

  // Section-2 full slider
  (function(){
    var box=document.getElementById('heroSlider'); if(!box) return;
    var slides=[].slice.call(box.querySelectorAll('.fslide'));
    var dotsWrap=document.getElementById('hsDots'), i=0, timer=null, DUR=2500, dots=[];
    slides.forEach(function(_,k){ var b=document.createElement('button'); b.className='fdot'+(k===0?' on':''); b.addEventListener('click',function(){show(k);start();}); if(dotsWrap)dotsWrap.appendChild(b); dots.push(b); });
    function show(n){ i=(n+slides.length)%slides.length; slides.forEach(function(s,k){s.classList.toggle('on',k===i);}); dots.forEach(function(d,k){d.classList.toggle('on',k===i);}); }
    function next(){show(i+1);} function prev(){show(i-1);}
    function start(){stop(); timer=setInterval(next,DUR);} function stop(){if(timer){clearInterval(timer);timer=null;}}
    var nx=document.getElementById('hsNext'), pv=document.getElementById('hsPrev');
    if(nx)nx.addEventListener('click',function(){next();start();});
    if(pv)pv.addEventListener('click',function(){prev();start();});
    box.addEventListener('mouseenter',stop); box.addEventListener('mouseleave',start);
    start();
  })();

  // Generic loop carousel (reviews + video)
  function loopCarousel(trackId, prevId, nextId, autoplayMs){
    var track=document.getElementById(trackId); if(!track) return;
    var busy=false, timer=null;
    function gap(){ return parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||0; }
    function step(){ var c=track.firstElementChild; return c ? c.getBoundingClientRect().width + gap() : 0; }
    function advance(){ if(busy)return; busy=true; track.style.transition='transform .6s cubic-bezier(.4,0,.2,1)'; track.style.transform='translateX(-'+step()+'px)';
      setTimeout(function(){ track.style.transition='none'; track.appendChild(track.firstElementChild); track.style.transform='translateX(0)'; busy=false; },630); }
    function retreat(){ if(busy)return; busy=true; track.style.transition='none'; track.insertBefore(track.lastElementChild, track.firstElementChild); track.style.transform='translateX(-'+step()+'px)';
      requestAnimationFrame(function(){ track.style.transition='transform .6s cubic-bezier(.4,0,.2,1)'; track.style.transform='translateX(0)'; setTimeout(function(){busy=false;},630); }); }
    function start(){ stop(); if(autoplayMs) timer=setInterval(advance,autoplayMs); } function stop(){ if(timer){clearInterval(timer);timer=null;} }
    var nx=document.getElementById(nextId), pv=document.getElementById(prevId);
    if(nx)nx.addEventListener('click',function(){advance();start();});
    if(pv)pv.addEventListener('click',function(){retreat();start();});
    track.addEventListener('mouseenter',stop); track.addEventListener('mouseleave',start); start();
  }
  loopCarousel('revTrack','revPrev','revNext',0);
  loopCarousel('vidTrack','vidPrev','vidNext',0);
});

/* Page interactions: FAQ accordion + form success (ported 1:1) */
window.handleContact=function(e){ if(e)e.preventDefault(); var f=document.getElementById('contactForm'); var s=document.getElementById('contact-success'); if(f)f.style.display='none'; if(s)s.style.display='block'; return false; };
window.handleAffiliate=function(e){ if(e)e.preventDefault(); if(e&&e.target)e.target.style.display='none'; var s=document.getElementById('aff-success'); if(s)s.style.display='block'; return false; };
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.faq-q').forEach(function(q){
    function toggle(){ var item=q.closest('.faq-item'); if(!item)return; item.classList.toggle('open'); }
    q.addEventListener('click', toggle);
    q.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } });
  });
});

/* AJAX Add to Cart — stay on the current page, show a toast, never redirect to /cart or checkout */
document.addEventListener('DOMContentLoaded', function(){
  function showToast(msg){ window.zrToast(msg); }
  function updateCartCount(count){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = count > 0 ? '(' + count + ')' : ''; });
  }
  document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if(btn) btn.disabled = true;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body: fd, headers: { 'Accept':'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
        .then(function(cart){ updateCartCount(cart.item_count); showToast('Added to cart'); })
        .catch(function(){ showToast('Could not add to cart — please try again'); })
        .finally(function(){ if(btn) btn.disabled = false; });
    });
  });
});

/* v75.46 toast: after Add to Cart a bar stays ~4 s at the bottom; tapping it opens the cart */
(function(){
  var el=null, timer=null;
  function make(){
    if(el) return el;
    var old=document.querySelector('.zr-toast'); if(old&&old.parentNode) old.parentNode.removeChild(old);
    el=document.createElement('a'); el.className='zr-toast'; el.href='/cart'; el.setAttribute('role','status'); el.setAttribute('aria-live','polite');
    el.innerHTML='<span class="zr-t-ic" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-10"/></svg></span><span class="zr-t-msg"></span><span class="zr-t-go">View Cart<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></span>';
    el.addEventListener('mouseenter',function(){ clearTimeout(timer); });
    el.addEventListener('mouseleave',function(){ hideLater(1600); });
    document.body.appendChild(el); return el;
  }
  function hideLater(ms){ clearTimeout(timer); timer=setTimeout(function(){ el.classList.remove('show'); },ms); }
  window.zrToast=function(msg){
    var t=make(), ok=!/could not|try again/i.test(msg||'');
    t.querySelector('.zr-t-msg').textContent=msg||'Added to cart';
    t.classList.toggle('is-err',!ok);
    if(ok){ t.setAttribute('href','/cart'); } else { t.removeAttribute('href'); }
    var row=document.querySelector('.pdp-info .buy-row'), r=row&&row.offsetParent?row.getBoundingClientRect():null;
    if(r&&r.width&&r.bottom>0&&r.top<window.innerHeight){
      t.classList.add('is-anchored'); t.style.left=(r.left+window.scrollX)+'px'; t.style.top=(r.bottom+window.scrollY+10)+'px'; t.style.width=r.width+'px';
    } else { t.classList.remove('is-anchored'); t.style.left=''; t.style.top=''; t.style.width=''; }
    t.classList.remove('show'); void t.offsetWidth; t.classList.add('show');
    hideLater(ok?4000:2600);
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',make); else make();
})();
